<template>
	<div>
		<div class="modal fade" id="MdVendedores">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel">Vendedor</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>Código</span>
							<input
								type="text"
								v-model="data.cod"
								disabled
								class="form-control"
							/>
						</div>
						<div class="clearfix"></div>

						<div class="col-sm-9">
							<span>Vendedor</span>
							<input
								type="text"
								v-model="data.vendedor"
								class="form-control"
							/>
						</div>
						<div class="col-sm-3">
							<span>Comissão</span>
							<div class="input-group">
								<input
									type="number"
									v-model="data.comissao"
									class="form-control"
								/>
								<span class="input-group-addon">%</span>
							</div>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
						<aBtn
							action="private-save-sellers"
							@click="save"
							text="Salvar"
							icon="save"
							type="primary"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import clone from 'js/clone';
	import toastr from 'toastr';
	import WBS from 'js/http';
	import aBtn from 'btn';

	let reset = { cod: null, vendedor: '', comissao: 0 };
	export default {
		name: 'ModalVendedores',
		components: { aBtn },
		data() {
			return {
				data: clone(reset),
			};
		},
		methods: {
			open(data = null) {
				if (data == null) this.data = clone(reset);
				else this.data = clone(data);
				$('#MdVendedores').modal('show');
			},
			save() {
				WBS.send('private-save-sellers', this.data, (resp) => {
					if (resp.status == 'success') {
						this.$emit('update');
						toastr.success('Dados salvos com sucesso!');
						$('#MdVendedores').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/sellers/modal.vue